import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";

type GenerateCoverLetterRequest = {
  resumeId: string;
  jobDescription: string;
};

type GenerateCoverLetterResponse = {
  coverLetter: string;
};

export const generateCoverLetter = async (data: GenerateCoverLetterRequest) => {
  const response = await axios.post<
    GenerateCoverLetterResponse,
    AxiosResponse<GenerateCoverLetterResponse>,
    GenerateCoverLetterRequest
  >("/cover-letter/generate", data);

  return response.data;
};

export const useGenerateCoverLetter = () => {
  const queryClient = useQueryClient();

  const {
    error,
    isPending: loading,
    mutateAsync: generateCoverLetterFn,
  } = useMutation({
    mutationFn: generateCoverLetter,
    onSuccess: (_, variables) => {
      // Invalidate the cover letter query to refetch the updated data
      queryClient.invalidateQueries({ queryKey: ["cover-letter", variables.resumeId] });
      queryClient.invalidateQueries({ queryKey: ["resumes"] });
    },
  });

  return { generateCoverLetter: generateCoverLetterFn, loading, error };
};
